import React from 'react';
import Table from 'UI/Table';
import { humanizeGB } from 'Decorators/SizeDecorator'
import AssetNameWithLabel from 'FoundationalComponents/AssetNameWithLabel'

export const VMTable = ({ vms, showCustomer = true }) => (
  <Table
    data={vms}
    columns={[
      { Header: 'VM', className: 'react-table-capacity-vm-cell', accessor: 'name', Cell: ({ value, original }) => (<AssetNameWithLabel name={value} label={original.asset_label} />) },
      showCustomer && { Header: 'Customer', className: 'react-table-capacity-vm-cell', accessor: 'customer_name', type: 'clientNameWithStatus'},
      { Header: 'Power State', className: 'react-table-capacity-vm-cell', accessor: 'power_state', type: 'powerState' },
      { Header: 'Number of CPUs', className: 'react-table-capacity-vm-cell', accessor: 'num_cpu', type: 'number' },
      { Header: 'Memory', className: 'react-table-capacity-vm-cell', accessor: 'memory_gb', type: 'number', Cell: ({ value }) => humanizeGB(value) },
      { Header: 'Provisioned Space', className: 'react-table-capacity-vm-cell', accessor: 'provisioned_space_gb', type: 'number', Cell: ({ value }) => humanizeGB(value) },
      { Header: 'Used Space', className: 'react-table-capacity-vm-cell', accessor: 'used_space_gb', type: 'number', Cell: ({ value }) => humanizeGB(value) },
    ]}
    tableProps={{
      defaultPageSize: vms.length,
      defaultSorted: [{ id: 'name', asc: true }],
      showPagination: false
    }} />
);
